import { render } from "./ProfileProducts.vue?vue&type=template&id=202b7e7d&ts=true"
import script from "./ProfileProducts.vue?vue&type=script&lang=ts"
export * from "./ProfileProducts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__